import React from "react";
import './common.css';

export default function PrivacyPolicy() {
  return (
    <div className="container">
      <header className="header">
        <h1 className="logo">Saral Platform</h1>
        <nav className="nav">
          <a href="/">Home</a>
          <a href="/SaralContact">CCaaS</a>
          <a href="/SaralModeration">Moderation</a>
          <a href="/SaralTranslate">Translation</a>
        </nav>
      </header>

      <section style={{padding: '3rem 2rem', maxWidth: '900px', margin: '0 auto'}}>
        <h1 style={{fontSize: '2.5rem', marginBottom: '1rem', color: '#0070f3'}}>Privacy Policy</h1>
        <p style={{fontSize: '0.9rem', color: '#777', marginBottom: '2rem'}}>Last Updated: February 22, 2025</p>

        <div style={{lineHeight: '1.8', fontSize: '1rem'}}>
          <h2 style={{fontSize: '1.8rem', marginTop: '2rem', marginBottom: '1rem', color: '#333'}}>1. Introduction</h2>
          <p>
            Welcome to Saral Platform ("we," "our," or "us"). We are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our services, including our Managed CCaaS, Content Moderation, and AI Translation services.
          </p>

          <h2 style={{fontSize: '1.8rem', marginTop: '2rem', marginBottom: '1rem', color: '#333'}}>2. Information We Collect</h2>
          <h3 style={{fontSize: '1.4rem', marginTop: '1.5rem', marginBottom: '0.75rem', color: '#555'}}>2.1 Information You Provide</h3>
          <p>We collect information that you voluntarily provide to us, including:</p>
          <ul style={{marginLeft: '2rem', marginBottom: '1rem'}}>
            <li>Contact information (name, email address, phone number)</li>
            <li>Account credentials (username, password)</li>
            <li>Business information (company name, job title)</li>
            <li>Payment information (processed securely through third-party payment processors)</li>
            <li>Communications with our support team</li>
          </ul>

          <h3 style={{fontSize: '1.4rem', marginTop: '1.5rem', marginBottom: '0.75rem', color: '#555'}}>2.2 Information Collected Automatically</h3>
          <p>When you use our services, we automatically collect:</p>
          <ul style={{marginLeft: '2rem', marginBottom: '1rem'}}>
            <li>Usage data (features accessed, time spent, interactions)</li>
            <li>Device information (IP address, browser type, operating system)</li>
            <li>Log data (access times, pages viewed, errors)</li>
            <li>Cookies and similar tracking technologies</li>
          </ul>

          <h3 style={{fontSize: '1.4rem', marginTop: '1.5rem', marginBottom: '0.75rem', color: '#555'}}>2.3 Service-Specific Data</h3>
          <p>Depending on which services you use:</p>
          <ul style={{marginLeft: '2rem', marginBottom: '1rem'}}>
            <li><strong>CCaaS:</strong> Call recordings, chat transcripts, customer interaction data</li>
            <li><strong>Content Moderation:</strong> Content submitted for moderation (text, images, audio, video)</li>
            <li><strong>Translation:</strong> Source and translated content, language preferences</li>
          </ul>

          <h2 style={{fontSize: '1.8rem', marginTop: '2rem', marginBottom: '1rem', color: '#333'}}>3. How We Use Your Information</h2>
          <p>We use the collected information for the following purposes:</p>
          <ul style={{marginLeft: '2rem', marginBottom: '1rem'}}>
            <li>Providing and maintaining our services</li>
            <li>Processing transactions and sending related information</li>
            <li>Improving and optimizing our services</li>
            <li>Personalizing your experience</li>
            <li>Communicating with you about updates, security alerts, and support</li>
            <li>Detecting and preventing fraud, abuse, and security incidents</li>
            <li>Complying with legal obligations</li>
            <li>Training and improving our AI models</li>
          </ul>

          <h2 style={{fontSize: '1.8rem', marginTop: '2rem', marginBottom: '1rem', color: '#333'}}>4. Data Sharing and Disclosure</h2>
          <p>We do not sell your personal information. We may share your information in the following circumstances:</p>
          <ul style={{marginLeft: '2rem', marginBottom: '1rem'}}>
            <li><strong>Service Providers:</strong> Third-party vendors who perform services on our behalf (cloud hosting, payment processing, analytics)</li>
            <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets</li>
            <li><strong>Legal Requirements:</strong> When required by law or to protect our rights and safety</li>
            <li><strong>With Your Consent:</strong> When you explicitly authorize us to share your information</li>
          </ul>

          <h2 style={{fontSize: '1.8rem', marginTop: '2rem', marginBottom: '1rem', color: '#333'}}>5. Data Security</h2>
          <p>
            We implement industry-standard security measures to protect your information, including:
          </p>
          <ul style={{marginLeft: '2rem', marginBottom: '1rem'}}>
            <li>Encryption of data in transit and at rest</li>
            <li>Regular security audits and penetration testing</li>
            <li>Access controls and authentication mechanisms</li>
            <li>Employee training on data protection</li>
            <li>SOC 2 Type II compliance</li>
          </ul>
          <p>
            However, no method of transmission over the internet is 100% secure. While we strive to protect your information, we cannot guarantee absolute security.
          </p>

          <h2 style={{fontSize: '1.8rem', marginTop: '2rem', marginBottom: '1rem', color: '#333'}}>6. Data Retention</h2>
          <p>
            We retain your information for as long as necessary to provide our services and fulfill the purposes outlined in this Privacy Policy. When you close your account, we will delete or anonymize your personal information within 90 days, unless we are required to retain it for legal or regulatory purposes.
          </p>

          <h2 style={{fontSize: '1.8rem', marginTop: '2rem', marginBottom: '1rem', color: '#333'}}>7. Your Rights and Choices</h2>
          <p>Depending on your location, you may have the following rights:</p>
          <ul style={{marginLeft: '2rem', marginBottom: '1rem'}}>
            <li><strong>Access:</strong> Request a copy of your personal information</li>
            <li><strong>Correction:</strong> Update or correct inaccurate information</li>
            <li><strong>Deletion:</strong> Request deletion of your personal information</li>
            <li><strong>Portability:</strong> Receive your data in a structured, machine-readable format</li>
            <li><strong>Opt-Out:</strong> Unsubscribe from marketing communications</li>
            <li><strong>Object:</strong> Object to certain processing of your information</li>
          </ul>
          <p>To exercise these rights, please contact us at <a href="mailto:privacy@saralplatform.com">privacy@saralplatform.com</a></p>

          <h2 style={{fontSize: '1.8rem', marginTop: '2rem', marginBottom: '1rem', color: '#333'}}>8. Cookies and Tracking Technologies</h2>
          <p>
            We use cookies and similar technologies to enhance your experience. You can control cookies through your browser settings. However, disabling cookies may limit your ability to use certain features of our services.
          </p>

          <h2 style={{fontSize: '1.8rem', marginTop: '2rem', marginBottom: '1rem', color: '#333'}}>9. International Data Transfers</h2>
          <p>
            Your information may be transferred to and processed in countries other than your country of residence. We ensure appropriate safeguards are in place to protect your information in accordance with this Privacy Policy and applicable laws.
          </p>

          <h2 style={{fontSize: '1.8rem', marginTop: '2rem', marginBottom: '1rem', color: '#333'}}>10. Children's Privacy</h2>
          <p>
            Our services are not intended for individuals under the age of 18. We do not knowingly collect personal information from children. If you believe we have collected information from a child, please contact us immediately.
          </p>

          <h2 style={{fontSize: '1.8rem', marginTop: '2rem', marginBottom: '1rem', color: '#333'}}>11. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. Your continued use of our services after such changes constitutes acceptance of the updated policy.
          </p>

          <h2 style={{fontSize: '1.8rem', marginTop: '2rem', marginBottom: '1rem', color: '#333'}}>12. Contact Us</h2>
          <p>
            If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us:
          </p>
          <ul style={{marginLeft: '2rem', marginBottom: '1rem', listStyle: 'none'}}>
            <li><strong>Email:</strong> <a href="mailto:privacy@saralplatform.com">privacy@saralplatform.com</a></li>
            <li><strong>Phone:</strong> <a href="tel:770-378-8627">770-378-8627</a></li>
            <li><strong>Address:</strong> Saral Platform, [Your Business Address]</li>
          </ul>
        </div>
      </section>

      <footer className="footer">
        &copy; 2025 Saral Platform. All rights reserved. | <a href="/privacy-policy" style={{color: '#777'}}>Privacy Policy</a>
      </footer>
    </div>
  );
}
